  /**
  * Extracts question-related content from an AI response and updates UI fields.
  *
  * @param {string} questionType - Type of question (e.g., "רב-ברירה", "התאמה").
  * @param {string} text - The raw response text from the AI model.
  * @param {Function} updateFields - Callback to update the UI with extracted values.
  */
  export const extractQuestionAndExplanation = (questionType, text, updateFields) => {
    // Extract data from XML-like tags using regex
    const questionMatch = text.match(/<exam_question>([\s\S]*?)<\/exam_question>/);
    const solutionMatch = text.match(/<solution>([\s\S]*?)<\/solution>/);
    const multipleChoiceAnswersMatch = text.match(/<answers>([\s\S]*?)<\/answers>/);
    const matchingDefinitionsMatch = text.match(/<matching_definitions>([\s\S]*?)<\/matching_definitions>/);
    const matchingExamplesMatch = text.match(/<matching_examples>([\s\S]*?)<\/matching_examples>/);
    const explanationMatch = text.match(/<explanation>([\s\S]*?)<\/explanation>/);
    const quotationMatch = text.match(/<quotations>([\s\S]*?)<\/quotations>/);
    const improvementMatch = text.match(/<changes>([\s\S]*?)<\/changes>/);

    // Extract and trim each piece if found
    const extractedQuestion = questionMatch ? questionMatch[1].trim() : null;
    const extractedSolution = solutionMatch ? solutionMatch[1].trim() : null;
    const extractedMultipleChoiceAnswers = multipleChoiceAnswersMatch? multipleChoiceAnswersMatch[1].trim(): null;
    const extractedMatchingDefinition = matchingDefinitionsMatch? matchingDefinitionsMatch[1].trim(): null;
    const extractedMatchingExamples = matchingExamplesMatch? matchingExamplesMatch[1].trim(): null;
    const extractedExplanation = explanationMatch? explanationMatch[1].trim(): null;
    const extractedQuotation = quotationMatch ? quotationMatch[1].trim() : null;
    const extractedImprovement = improvementMatch? improvementMatch[1].trim(): null;

    let finalQuestion = extractedQuestion;

    console.log(`improvementMatch: ${improvementMatch}`);
    console.log(`extractedImprovement: ${extractedImprovement}`);

    // Append multiple-choice answers to the question if needed
    let answers;
    if (questionType === "רב-ברירה" && extractedMultipleChoiceAnswers) {
      const cleanedAnswers = extractedMultipleChoiceAnswers
        .split("\n")
        .map((line) => line.trimStart()) // Remove leading spaces
        .join("\n");
      answers = cleanedAnswers
      finalQuestion += "\n" + cleanedAnswers;
    }

    // if (questionType === "התאמה") {
    //   const cleanedMatchingDefinition = extractedMatchingDefinition.split("\n").map((line) => line.trimStart()).join("\n")
    //   const cleanedMatchingExamples = extractedMatchingExamples.split("\n").map((line) => line.trimStart()).join("\n")
    //   finalQuestion += "\n" + cleanedMatchingDefinition + "\n\nתרחשים:\n" + cleanedMatchingExamples;
    // }

    // Push extracted data to UI state
    updateFields({
      question: finalQuestion,
      answers: answers,
      solution: extractedSolution,
      quotation: extractQuotations(extractedQuotation),
      matchingDefinitions: extractedMatchingDefinition,
      matchingExamples: extractedMatchingExamples,
      changeDescription: extractedImprovement || "",
    });
  };

  /**
   * Extracts quotations from a string containing one or more <quotation>...</quotation> tags.
   * Splits long quotes into smaller parts based on paragraph breaks or sentence boundaries.
   *
   * @param {string} extractedQuotation - Raw AI-generated string containing quotation tags.
   * @returns {string[]} An array of cleaned, meaningful quote fragments.
   */
  function extractQuotations(extractedQuotation) {
    const quotationRegex = /<quotation>\s*([\s\S]*?)\s*<\/quotation>/g;
    const matches = [];
    let match;

    while ((match = quotationRegex.exec(extractedQuotation)) !== null) {
      const rawQuote = match[1].trim();

      // Split long quotes into logical parts:
      // - by double newlines (paragraph breaks)
      // - or sentence endings followed by a capital letter (likely next sentence)
      const splitParts = rawQuote
        .split(/\n{2,}|(?<=[.?!])\s+(?=[A-Z])/g)
        .map((part) => part.trim())
        .filter((part) => part.length >= 20); // Skip trivial or short fragments

      // Add valid segments to the results array
      matches.push(...splitParts);
    }

    return matches;
  }